import { isCzechMarket } from './isCzechMarket';
import { isSlovakMarket } from './isSlovakMarket';

export type IdentityDocumentValidationCountry = 'CZ' | 'SK';

export function resolveIdentityDocumentValidationCountry(): IdentityDocumentValidationCountry | undefined {
  if (isCzechMarket()) {
    return 'CZ';
  }
  if (isSlovakMarket()) {
    return 'SK';
  }
  return undefined;
}

export function isIdentityDocumentValidationMarket() {
  return isCzechMarket() || isSlovakMarket();
}
